import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      {icon && <div className="mb-4 text-[#6b7280]">{icon}</div>}
      <h3 className="text-lg font-medium text-[#f5f5f5] mb-1">{title}</h3>
      {description && <p className="text-[#999] text-sm max-w-md mb-4">{description}</p>}
      {action && <div>{action}</div>}
    </div>
  );
}
